import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@shared/config/routes'
import { useAppStore } from '@/store/useAppStore'
import { isGraceVisible } from '@features/subscription'
import { GracePeriodModal } from './GracePeriodModal'

/**
 * Глобальный попап грейс-периода. Монтируется один раз в shell (web/tg) и
 * читает profile.subscription из стора, поэтому всплывает сразу при входе в
 * приложение, а не только на странице профиля.
 *
 * Показывается один раз за сессию: после закрытия `dismissed` остаётся true до
 * перезагрузки страницы (компонент висит в shell и не ремаунтится при навигации).
 * Если grace_active слетел в false и снова стал true — показываем заново.
 */
export const GracePeriodPopup = () => {
  // Дату окончания берём из подписки, а не из профиля: профиль мог остаться
  // снимком месячной давности, и попап всплывал бы у продлившихся людей.
  const graceFlag = useAppStore(
    s => s.profile?.subscription?.grace_active === true
  )
  const expiresAt = useAppStore(s => s.subscription.expiresAt)
  const graceActive = isGraceVisible(graceFlag, expiresAt)
  const provider = useAppStore(s => s.profile?.subscription?.provider ?? null)
  const [dismissed, setDismissed] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (!graceActive) setDismissed(false)
  }, [graceActive])

  if (!graceActive || dismissed) return null

  const goToProfile = () => {
    setDismissed(true)
    navigate(ROUTES.PROFILE)
  }

  return (
    <GracePeriodModal
      provider={provider}
      onGoToProfile={goToProfile}
      onClose={() => setDismissed(true)}
    />
  )
}
